module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"UPLOADIMAGE":"Upload Image","SAVEIMAGE":"Save Image","CANCEL":"Cancel","CLOSE":"Close","FILEISTOOLARGERMAXFILEIS":"File is too large, max file is {param}.","TYPEERROR":"File extensions should be {param}."},"ar":{"CANCEL":"الغاء","CLOSE":"أغلق","SAVEIMAGE":"احفظ الصورة","UPLOADIMAGE":"تحميل الصور","FILEISTOOLARGERMAXFILEIS":"ملحقات الملفات يجب أن تكون {param}.","TYPEERROR":"ملحقات الملفات يجب أن تكون {param}."}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/dialogs/Upload.vue
// module id = 313
// module chunks = 1